import React, { useEffect, useState } from 'react';
import * as XLSX from 'xlsx';
import { connect } from 'react-redux';
import { SvgIcon } from '@material-ui/core';
import defaultStyles from './SequencePreviews.module.css';
import jlrStyles from './SequencePreviewsJlr.module.css';
import {
  AsnWarningDialog,
  AttributesSelector,
  HeijunkaSequencePreviewTable,
} from '../../components';
import { AuthChecker, Button } from '../../atomicComponents';
import { Redirect, useHistory } from 'react-router-dom';
import {
  SVG_ICON_PATHS,
  API_RESOURCE_URLS,
  DATE_FORMAT,
  USER_OPERATIONS,
  APPLICATION_VARIANTS,
  MESSAGE_TYPE,
  DISPLAY_MESSAGES,
} from '../../constants';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { AiFillFile } from 'react-icons/ai';
import { IoMdCloudDownload } from 'react-icons/io';
import { IoMdCloudUpload } from 'react-icons/io';
import { MdClose } from 'react-icons/md';
import AuthEnabledButton from '../../components/AuthEnabledButton/AuthEnabledButton';
import { usePlantAndLinesStore } from '../../providers/PlantAndLinesStore/PlantAndLinesStore';
import resequencingActions from '../../redux/features/resequencing/actions';
import { API } from '../../apis/api';
import { usePopupManager } from '../../providers/PopupManager/PopupManager';
import {
  buildErrorMessage,
  fetchSequenceForDatePlantAndLine,
} from '../../apis/calls';
import { getDatesForRange, setStylesAccordingToPlant } from '../../utils/utils';
import AssignShiftPopup from '../../components/AssignShiftPopup/AssignShiftPopup';
import { OPTIONAL_ATTRIBUTES } from '../../staticData';
import config from '../../config/config';

const SequencePreviews = ({
  setActiveDate,
  activeDate,
  startDate,
  endDate,
  isResequencingFlowActive,
  endResequencingFlow,
}) => {
  const history = useHistory();
  const { APPLICATION_VARIANT } = config;
  const { showLoading, showInternalError, showError, showPopup } = usePopupManager();

  const [line] = usePlantAndLinesStore().lineState;
  const [plant] = usePlantAndLinesStore().plantState;
  const [extractedData, setExtractedData] = useState([]);
  const [
    isDownloadOrUploadDialogOpen,
    setIsDownloadOrUploadDialogOpen,
  ] = useState(false);

  const [styles, setStyles] = useState(defaultStyles);

  const [selectedOptionalColNames, setSelectedOptionalColNames] = useState([
    OPTIONAL_ATTRIBUTES.FAMILY,
    OPTIONAL_ATTRIBUTES.BUILD_CARD_NUMBER,
    OPTIONAL_ATTRIBUTES.FBV_VENDOR_NAME,
    OPTIONAL_ATTRIBUTES.POWER_STEERING,
    OPTIONAL_ATTRIBUTES.COUNTRY,
    OPTIONAL_ATTRIBUTES.MARKET,
  ]);
  const [dates, setDates] = useState([]);
  const [isWarningOpen, setIsWarningOpen] = useState(false);
  const [sequenceData, setSequenceData] = useState({
    loading: false,
    data: [],
  });

  const [isShiftAssignmentPopupOpen, setIsShiftAssignmentPopupOpen] = useState(
    false,
  );
  const [shopId, setShopId] = useState(null);

  const [activeShifts, setActiveShifts] = useState([]);

  const [asnData, setAsnData] = useState([]);

  const isLucknowProlifePlant = plant.label === 'Lucknow-Prolife'

  const parentName = isLucknowProlifePlant ? 'Part' : 'VC'

  const showDownloadAndUploadDialog = () => {
    setIsDownloadOrUploadDialogOpen(true);
  };
  const handleDonloadOrUploadDialogueClose = () => {
    setIsDownloadOrUploadDialogOpen(false);
  };


  const redirectToResequenceForDate = () => {
    if (window.navigator.onLine)
      history.push(`/resequence/${activeDate.format(DATE_FORMAT.ISO)}`);
    else
      window.alert(
        'No internet connection. Pls check your network connection and try again.',
      );
  };

  const redirectToPlanning = () => {
    history.push('/planning');
  };

  const moveToNextDate = (currentDate, availableDates) => {
    const currentDateIndex = availableDates.findIndex(date =>
      date.isSame(currentDate, 'days'),
    );
    const nextDate = availableDates[currentDateIndex + 1];
    if (nextDate) setActiveDate(nextDate);
  };

  const handleNext = () => {
    if (activeDate?.isSame(dates[dates.length - 1])) {
      return setIsWarningOpen(true);
    }
    moveToNextDate(activeDate, dates);
  };

  const generateAsn = () => {
    const startDateString = startDate.format(DATE_FORMAT.ISO);
    const endDateString = endDate.format(DATE_FORMAT.ISO);

    const closeLoadingPopup = showLoading();

    API.post(API_RESOURCE_URLS.VC_ASN, {
      from: startDateString,
      to: endDateString,
      line: line.value,
      plant: plant.value,
    })
      .then(() => {
        closeLoadingPopup();
        endResequencingFlow();
      })
      .catch(err => {
        console.error('Failed to generate ASN', buildErrorMessage(err));
        if (
          err.response &&
          err.response.data &&
          err.response.data.errorMessage
        ) {
          const errorMessage = err.response.data.errorMessage;
          showError({
            contextText: errorMessage,
            info: '',
          });
        }
        else {
          showInternalError();
        }

      });
  };

  const handleShiftAssignment = () => {
    setIsShiftAssignmentPopupOpen(true);
  };

  const sortBySerialNumber = (a, b) => {
    if (a.serialNumber > b.serialNumber) return 1;
    if (a.serialNumber < b.serialNumber) return -1;
    return 0;
  };

  const loadSequenceDataForDate = async date => {
    const dateString = date.format(DATE_FORMAT.ISO);
    const closeLoadingPopup = showLoading();
    try {
      setSequenceData(prevState => ({ ...prevState, loading: true }));
      const response = await fetchSequenceForDatePlantAndLine(
        dateString,
        plant.value,
        line.value,
      );
      const sortedData = response.data.sort(sortBySerialNumber);
      setSequenceData({
        data: sortedData,
        loading: false,
      });
      closeLoadingPopup();
    } catch (err) {
      console.error('failed to load sequence err:' + buildErrorMessage(err));
      setSequenceData({
        data: [],
        loading: false,
      });
      if (err.response?.status === 400) {
        showPopup({
          type: MESSAGE_TYPE.FAILURE,
          error: err,
          contextText: DISPLAY_MESSAGES.ASN_GENERATION_ERROR,
        });
      }
      else {
        showInternalError();
      }
    }
  };

  const downloadSequenceDataAsExcel = () => {
    if (sequenceData.data.length === 0) {
      showError({
        contextText: `Sequence Data is Not generated. Please Update Quantity`,
      });
      return;
    }

    let excelData = [];
    let columnWidths = [];

    if (plant.label === 'Pantnagar') {
      excelData = sequenceData.data.map((seq, index) => ({
        serialNumber: index + 1,
        vc: seq.vc,
        category: seq.category,
        market: seq.market,
        countryCode: seq.countryCode,
        defence: seq.defence,
        fbv: seq.fbv,
        fbvVendorCode: seq.fbvVendorCode,
        buildCardNumber: seq.buildCardNumber,
        powerSteering: seq.powerSteering,
        colourCode: seq.colourCode,
        evrNumber: seq.evrNumber,
        shiftId: null,
        shiftName: null,
      }));
    } else {
      excelData = sequenceData.data.map(item => ({
        serialNumber: item.serialNumber,
        vc: item.vc,
        description: item.attributes.description,
        family: item.attributes.family,
        // Add other properties if needed
      }));

      columnWidths = [
        { wch: 12 }, // Width for serialNumber column
        { wch: 15 }, // Width for vc column
        { wch: 25 }, // Width for description column
        { wch: 10 }, // Width for family column
      ];
    }

    const worksheet = XLSX.utils.json_to_sheet(excelData);
    if (columnWidths.length > 0) {
      worksheet['!cols'] = columnWidths;
    }

    // Generate Excel file
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sequence Data');

    // Generate Excel file
    const excelFileName = 'sequence_data.xlsx';
    XLSX.writeFile(workbook, excelFileName);
  };

  const loadActiveShiftsForPlantShopLine = async (
    plantId,
    shopId,
    lineId,
    from,
    to,
  ) => {
    if (!plantId && !shopId && !lineId && !from && !to) return;
    try {
      const response = await API.get(
        API_RESOURCE_URLS.shiftAssignments(plantId, shopId, lineId, from, to),
      );
      const formattedShifts = response.data.map(record => ({
        value: record.shiftId,
        label: record.shiftName,
        isAvailable: true,
      }));
      const sortedShifts = formattedShifts.sort((a, b) => {
        if (a.label < b.label) {
          return -1;
        }
        if (a.label > b.label) {
          return 1;
        }
        return 0;
      });
      setActiveShifts(sortedShifts);
    } catch (error) {
      console.error(buildErrorMessage(error));
      showInternalError({ error: error });
      setActiveShifts([]);
    }
  };

  const loadShopIdForSelectedLine = async lineId => {
    try {
      const response = await API.get(
        API_RESOURCE_URLS.lineDetailsByLineId(lineId), // TODO: get from planning instead of digital twin service
      );
      const lineDetails = response.data;
      setShopId(lineDetails.shop?.id);
    } catch (error) {
      console.error(buildErrorMessage(error));
      showInternalError({ error: error });
      setShopId(null);
    }
  };

  const getAsnsPayloadWithBulkShiftsAssigned = (
    sortedRequiredShifts,
    requiredAvailableAsns,
    assignmentsToShiftLabelsMap,
  ) => {
    const payloadWithShiftsAssigned = [];

    const requiredAvailableAsnsPayload = requiredAvailableAsns.map(
      ({ id }) => ({ id }),
    );

    for (const shift of sortedRequiredShifts) {
      const asnsWithCurrentShiftAssigned = requiredAvailableAsnsPayload
        .slice(
          payloadWithShiftsAssigned.length,
          payloadWithShiftsAssigned.length +
          assignmentsToShiftLabelsMap[shift.label],
        )
        .map(data => ({ materialId: data.id, shiftId: shift.value }));
      payloadWithShiftsAssigned.push(...asnsWithCurrentShiftAssigned);
    }
    return payloadWithShiftsAssigned;
  };

  const bulkAssignShift = async (
    sortedRequiredShifts,
    requiredAvailableAsns,
    assignmentsToShiftLabelsMap,
  ) => {
    const asnsPayload = getAsnsPayloadWithBulkShiftsAssigned(
      sortedRequiredShifts,
      requiredAvailableAsns,
      assignmentsToShiftLabelsMap,
    );

    await API.patch(
      API_RESOURCE_URLS.assignShiftToMaterialWhileSequencing(
        plant.value,
        line.value,
      ),
      asnsPayload,
      {
        params: {
          date: activeDate.format(DATE_FORMAT.ISO),
        },
      },
    );
    loadSequenceDataForDate(activeDate);
  };

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    if (file) {
      try {
        const excelData = await parseExcelFile(file);
        const isValidFormat = validateExcelData(excelData);

        if (isValidFormat) {
          redirectToexcelResequenceForDate(excelData);
        } else {
          console.error('Invalid Excel Data Format');
        }
      } catch (error) {
        console.error('Error parsing Excel file:', error);
      }
    }
  };

  const parseExcelFile = async (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = (event) => {
        try {
          const data = event.target.result;
          const workbook = XLSX.read(data, { type: 'binary' });
          const sheetName = workbook.SheetNames[0];
          const sheet = workbook.Sheets[sheetName];
          const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });

          // Extract data based on headers
          const extractedData = extractDataBasedOnHeaders(jsonData);

          resolve(extractedData);
        } catch (error) {
          reject(error);
        }
      };

      reader.readAsBinaryString(file);
    });
  };

  const extractDataBasedOnHeaders = (jsonData) => {

    const headers = jsonData[0];

    const serialNumberIndex = headers.indexOf('serialNumber');
    const vcIndex = headers.indexOf('vc');
    const descriptionIndex = headers.indexOf('description');
    const familyIndex = headers.indexOf('Family');

    // Pantnagar specific headers
    const categoryIndex = headers.indexOf('category');
    const marketIndex = headers.indexOf('market');
    const countryCodeIndex = headers.indexOf('countryCode');
    const defenceIndex = headers.indexOf('defence');
    const fbvIndex = headers.indexOf('fbv');
    const fbvVendorCodeIndex = headers.indexOf('fbvVendorCode');
    const buildCardNumberIndex = headers.indexOf('buildCardNumber');
    const powerSteeringIndex = headers.indexOf('powerSteering');
    const colourCodeIndex = headers.indexOf('colourCode');
    const evrNumberIndex = headers.indexOf('evrNumber');
    const shiftIdIndex = headers.indexOf('shiftId');
    const shiftNameIndex = headers.indexOf('shiftName');

    const extractedData = jsonData.slice(1).map((row) => {
      const data = {
        serialNumber: row[serialNumberIndex],
        vc: row[vcIndex],
        description: row[descriptionIndex],
        family: row[familyIndex],
      };

      if (plant.label === 'Pantnagar') {
        data.category = row[categoryIndex];
        data.market = row[marketIndex];
        data.countryCode = row[countryCodeIndex];
        data.defence = row[defenceIndex];
        data.fbv = row[fbvIndex];
        data.fbvVendorCode = row[fbvVendorCodeIndex];
        data.buildCardNumber = row[buildCardNumberIndex];
        data.powerSteering = row[powerSteeringIndex];
        data.colourCode = row[colourCodeIndex];
        data.evrNumber = row[evrNumberIndex];
        data.shiftId = row[shiftIdIndex];
        data.shiftName = row[shiftNameIndex];
      }

      return data;
    });
    setExtractedData(extractedData);

    return extractedData;
  };

  const validateExcelData = (excelData) => {
    if (excelData === 0) {
      console.error('Empty Excel Data');
      return false;
    }
    return true;
  };

  const redirectToexcelResequenceForDate = (extractedData) => {
    if (window.navigator.onLine) {
      history.push({
        pathname: `/excelresequence/${activeDate.format(DATE_FORMAT.ISO)}`,
        state: { extractedData: extractedData }
      });
    } else {
      window.alert(
        'No internet connection. Please check your network connection and try again.',
      );
    }
  };

  useEffect(() => {
    if (line.value) {
      loadShopIdForSelectedLine(line.value);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [line]);

  useEffect(() => {
    if (activeDate && shopId) {
      loadActiveShiftsForPlantShopLine(
        plant.value,
        shopId,
        line.value,
        activeDate.format(DATE_FORMAT.ISO),
        activeDate.format(DATE_FORMAT.ISO),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [plant.value, shopId, line.value, activeDate]);

  useEffect(() => {
    const dateRange = getDatesForRange(startDate, endDate);
    setDates(dateRange);
    setActiveDate(activeDate || dateRange[0]);
  }, [startDate, endDate, setActiveDate, activeDate]);

  useEffect(() => {
    activeDate && loadSequenceDataForDate(activeDate);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeDate]);

  useEffect(() => {
    if (sequenceData.data.length > 0) {
      const formattedData = sequenceData.data.map(record => ({
        id: record.id,
        asnId: record.asnId,
        status: record.status,
        serialNumber: record.serialNumber,
      }));
      setAsnData(formattedData);

      sequenceData.data.map(record => record.shiftId).every(record => record) // show shift column when shifts are assigned to VCs
        ? setSelectedOptionalColNames(prev => ['Shift', ...prev])
        : setSelectedOptionalColNames(prev => [...prev]);
    }
  }, [sequenceData.data]);

  useEffect(() => {
    setStylesAccordingToPlant(plant, setStyles, defaultStyles, jlrStyles);
  }, [plant]);

  if (!isResequencingFlowActive) return <Redirect to="/planning" />;

  return (
    <>
      <div className={styles.container}>
        <div className={styles.toolbar}>
          <div className={styles.lineName}>{line.label}</div>
          <div className={styles.span}>
            <span>Heijunka</span>
            <span style={{ marginLeft: "4px" }}>
              <strong>Sequence</strong>
            </span>
          </div>
          <div className={styles.dragAndDropNote}>
            Note: Define your preferred order for {parentName} Drop by dragging each into
            the desired position before generating ASNs.
          </div>
          <AttributesSelector
            attributeSelectorForChassisSequence={true}
            buttonClassName={styles.attributesSel}
            selectedOptionalCols={selectedOptionalColNames}
            applyColumnsSelection={(selection) => {
              setSelectedOptionalColNames(selection);
            }}
            isShiftPresent={true}
          />
          <Button
            variant="tertiary"
            style={{
              fontSize: 14,
              padding: "0 1.8em",
              marginLeft: "2em",
            }}
            onClick={() => redirectToResequenceForDate(activeDate)}
            disabled={!activeDate}
          >
            Resequence
          </Button>
        </div>
        <div className={styles.tableContainer}>
          <HeijunkaSequencePreviewTable
            selectedOptionalColNames={selectedOptionalColNames}
            sequenceData={sequenceData}
          />
        </div>
        <div className={styles.footer}>
          <Button className={styles.cancelButton} onClick={redirectToPlanning}>
            Cancel
          </Button>
          {APPLICATION_VARIANT === APPLICATION_VARIANTS.MES4_EV || plant.label === 'Pantnagar' ? (
            <>
              <Button
                variant="tertiary"
                style={{
                  fontSize: 14,
                  padding: "0 1.8em",
                  marginLeft: "2em",
                }}
                operation={USER_OPERATIONS.CREATE_CHASSIS_PLAN_QUANTITY}
                isIconButton
                className={styles.uploadButton}
                onClick={showDownloadAndUploadDialog}
                data-testid="upload-btn"
                disabled={sequenceData.data.length === 0}
              >
                Upload Sequence
              </Button>

              <Dialog
                className={styles.uploadPopip}
                open={isDownloadOrUploadDialogOpen}
                onClose={handleDonloadOrUploadDialogueClose}
                aria-labelledby="draggable-dialog-title"
              >
                <DialogTitle
                  style={{ cursor: "move" }}
                  id="draggable-dialog-title"
                >
                  <span>
                    <AiFillFile className={styles.fileIcon} />
                    <span className={styles.title}>Sequence </span>
                    <MdClose
                      className={styles.cancelIcon}
                      onClick={handleDonloadOrUploadDialogueClose}
                    />
                  </span>
                </DialogTitle>
                <DialogContent>
                  <div>
                    <Button
                      className={styles.downloadTemplateButton}
                      onClick={downloadSequenceDataAsExcel}
                    >
                      <IoMdCloudDownload className={styles.downloadIcon} />

                      <span className={styles.label}>
                        <span className={styles.mainText}>
                          Sequence Download
                        </span>
                      </span>
                    </Button>

                    <Button
                      className={styles.uploadExcelButton}
                      onClick={() => {
                        document.getElementById("fileInput").click();
                      }}
                    >
                      <IoMdCloudUpload className={styles.uploadExcelIcon} />
                      <span className={styles.label}>
                        <span className={styles.mainText}>Sequence Upload</span>
                      </span>
                      <input
                        type="file"
                        id="fileInput"
                        accept=".xlsx, .xls"
                        style={{ display: "none" }}
                        onChange={handleFileUpload}
                      />
                    </Button>
                  </div>
                  <p className={styles.message}>
                    **Please use the Download Sequence for uploading ReSequence
                    in the system.
                  </p>
                </DialogContent>
              </Dialog>
            </>
          ) : null}
          {sequenceData?.data
            .map((record) => record.shiftId)
            .every((record) => record) ? (
            <>
              <AuthChecker operation={USER_OPERATIONS.ASSIGN_SHIFT_TO_MATERIAL}>
                {() => (
                  <Button
                    className={styles.assignShiftButton}
                    variant="contained"
                    data-testid="assign-shift-btn"
                    onClick={handleShiftAssignment}
                  >
                    Assign Shift
                  </Button>
                )}
              </AuthChecker>
              <Button
                className={styles.footerButton}
                variant="contained"
                data-testid="gen-asn-btn"
                onClick={handleNext}
              >
                {activeDate?.isSame(dates[dates.length - 1], "days")
                  ? "Generate ASN"
                  : "Next"}
              </Button>
            </>
          ) : (
            <>
              <AuthChecker operation={USER_OPERATIONS.ASSIGN_SHIFT_TO_MATERIAL}>
                {() => (
                  <Button
                    className={styles.footerButton}
                    variant="contained"
                    data-testid="assign-shift-btn"
                    onClick={handleShiftAssignment}
                  >
                    Assign Shift
                  </Button>
                )}
              </AuthChecker>
            </>
          )}
          <div className={styles.datesContainer}>
            <div className={styles.datesDiv}>
              <span className={styles.dateLabel}>Date</span>
              <span className={styles.dateString}>
                {dates[0] && dates[0].format("DD-MM-YYYY")}
              </span>
            </div>
          </div>
        </div>
      </div>
      <AsnWarningDialog
        open={isWarningOpen}
        handleClose={() => setIsWarningOpen(false)}
        generateAsn={generateAsn}
      />
      <AssignShiftPopup
        open={isShiftAssignmentPopupOpen}
        closeForm={() => setIsShiftAssignmentPopupOpen(false)}
        shifts={activeShifts}
        refreshData={() => true}
        bulkAssignShift={bulkAssignShift}
        dateOfAsns={activeDate}
        totalQuantities={sequenceData.data.length || 0}
        asns={asnData}
      />
    </>
  );
};

SequencePreviews.propTypes = {};

export default connect(
  ({ resequencing }) => ({
    startDate: resequencing.startDate,
    endDate: resequencing.endDate,
    activeDate: resequencing.activeDate,
    isResequencingFlowActive: resequencing.isResequencingFlowActive,
  }),
  {
    setActiveDate: resequencingActions.setActiveDate,
    endResequencingFlow: resequencingActions.endResequencingFlow,
  },
)(SequencePreviews);
